import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Button, Card, Grid, TextField, Typography } from "@mui/material";
import EditText from "../../components/EditText";
import PhoneInput from "react-phone-input-2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "react-phone-input-2/lib/bootstrap.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import Faq from "../faq";
import {
  useLazyGetCmsQuery,
  usePostCmsMutation,
  useUpdateCmsMutation,
} from "../../services/cms";
import { Loader, showError, showToast } from "../../constants";
import AboutUs from "../abouUs";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { Permissions } from "../../types/User";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const userData = useAuth();
  const navigate = useNavigate();
  const [aboutUs, setAboutUs] = useState<string>("");
  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [termsOfService, setTermsOfService] = useState<string>("");
  const [legal, setLegal] = useState<string>("");
  const [value, setValue] = React.useState(0);
  const [phoneCode, setPhoneCode] = useState("+91");
  const [cmsDetails, getCmaDetailData] = useLazyGetCmsQuery();
  const [updateCms, { isLoading }] = useUpdateCmsMutation();

  const [hidePermission, setHidePermission] = useState<
    Permissions | null | undefined
  >(null);

  const checkPermission = () => {
    const permission = userData?.permissions;
    if (permission?.length) {
      let idx = -1;
      idx = permission?.findIndex(
        (ele: Permissions) => ele?.label === "Manage CMS"
      );
      if (idx > -1) {
        setHidePermission(permission[idx]);
      } else {
        navigate(-1);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneCode(country?.dialCode);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),

      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      const body = {
        email: formik.values.email,
        phone: formik.values.phone,
        countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
        AboutUs: aboutUs,
        TermsandConditions: termsOfService,
        privacyPolicy: privacyPolicy,
        legal: legal,
      };
      try {
        const response = await updateCms({ body }).unwrap();
        if (response?.statusCode === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        console.log(error, "error");
        showError(error?.data?.message || "");
      }
    },
  });

  const getCmsDetail = async () => {
    try {
      const res = await cmsDetails({}).unwrap();
      if (res?.statusCode === 200 && res?.data?.length) {
        formik.setFieldValue("email", res?.data[0]?.email);
        formik.setFieldValue("phone", res?.data[0]?.phone);
        setAboutUs(res?.data[0]?.AboutUs);
        setPrivacyPolicy(res?.data[0]?.privacyPolicy || " ");
        setLegal(res?.data[0]?.legal || " ");
        setTermsOfService(res?.data[0]?.TermsandConditions || " ");
        setPhoneCode(res?.data[0]?.countryCode || "");
      }
    } catch (error: any) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (userData && userData?.permissions?.length) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    getCmsDetail();
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={isLoading || getCmaDetailData?.isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>Manage CMS</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="About Us" {...a11yProps(0)} />
              <Tab label="Contact Us" {...a11yProps(1)} />
              <Tab label="Terms and Conditions" {...a11yProps(2)} />
              <Tab label="Privacy Policy" {...a11yProps(3)} />
              {/* <Tab label="Legal" {...a11yProps(4)} /> */}
              <Tab label="FAQ's" {...a11yProps(4)} />
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <AboutUs hidePermission={hidePermission} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography className="custom_label">Email</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"email"}
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      id="email"
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      inputProps={{ maxLength: 40 }}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className="custom_label">
                      Phone Number
                    </Typography>
                    <PhoneInput
                      enableSearch={true}
                      value={phoneCode + formik.values.phone}
                      country={"us"}
                      inputClass="phoneInput"
                      inputStyle={{ width: "100%" }}
                      buttonClass="phoneBtn"
                      placeholder="Phone Number"
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <h6 className="err_msg">
                        {formik.touched.phone && formik.errors.phone}
                      </h6>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                {hidePermission?.isEdit || userData?.role === "ADMIN" ? (
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      Save
                    </Button>
                  </div>
                ) : null}
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <form onSubmit={formik.handleSubmit}>
                <EditText
                  content={termsOfService}
                  setContent={setTermsOfService}
                />
                {hidePermission?.isEdit || userData?.role === "ADMIN" ? (
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      Save
                    </Button>
                  </div>
                ) : null}
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <form onSubmit={formik.handleSubmit}>
                <EditText
                  content={privacyPolicy}
                  setContent={setPrivacyPolicy}
                />
                {hidePermission?.isEdit || userData?.role === "ADMIN" ? (
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      Save
                    </Button>
                  </div>
                ) : null}
              </form>
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={4}>
              <form onSubmit={formik.handleSubmit}>
                <EditText content={legal} setContent={setLegal} />
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </CustomTabPanel> */}

            <CustomTabPanel value={value} index={4}>
              <Faq hidePermission={hidePermission} />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageCms;
